var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Payment method icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "visa-logo",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.668 21.1443H11.9217L9.86232 13.0565C9.76457 12.6844 9.55702 12.3555 9.25172 12.2005C8.48982 11.811 7.65026 11.5009 6.73438 11.3446V11.0332H11.1585C11.7691 11.0332 12.227 11.5009 12.3033 12.0442L13.3719 17.8782L16.1169 11.0332H18.7869L14.668 21.1443ZM20.3133 21.1443H17.7197L19.8554 11.0332H22.4491L20.3133 21.1443ZM25.8046 13.8343C25.881 13.2897 26.3389 12.9783 26.8732 12.9783C27.7127 12.9001 28.6273 13.0565 29.3905 13.4447L29.8485 11.2677C29.0852 10.9564 28.2457 10.8 27.4838 10.8C24.9664 10.8 23.1347 12.2005 23.1347 14.1443C23.1347 15.623 24.4322 16.3995 25.348 16.8672C26.3389 17.3336 26.7205 17.645 26.6442 18.1114C26.6442 18.811 25.881 19.1224 25.1191 19.1224C24.2032 19.1224 23.2873 18.8892 22.4491 18.4996L21.9911 20.6779C22.907 21.0661 23.8979 21.2225 24.8138 21.2225C27.6364 21.2993 29.3905 19.9001 29.3905 17.8C29.3905 15.1553 25.8046 15.0003 25.8046 13.8343ZM38.4677 21.1443L36.4083 11.0332H34.1963C33.7383 11.0332 33.2804 11.3446 33.1277 11.811L29.3142 21.1443H31.9842L32.5171 19.6669H35.7977L36.103 21.1443H38.4677ZM34.5779 13.7561L35.3398 17.5668H33.204L34.5779 13.7561Z",
    fill: "#172B85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.9c41678398f0c63107f1e606475985d2.svg";
export { ForwardRef as ReactComponent };